import React from "react";

import "./loader.css";

const Loader = () => {
  return (
    <div className="ng-tns-c93-0">
      <div className="ngx-spinner-overlay ng-tns-c93-0 ng-trigger ng-trigger-fadeIn ng-star-inserted">
        <div className="ng-tns-c93-0 la-3x la-ball-scale-multiple ng-star-inserted">
          <div className="ng-tns-c93-0 ng-star-inserted"></div>
          <div className="ng-tns-c93-0 ng-star-inserted"></div>
          <div className="ng-tns-c93-0 ng-star-inserted"></div>
        </div>
        <div className="loading-text ng-tns-c93-0"></div>
      </div>
    </div>
  );
};

export default Loader;
